module.exports = __webpack_public_path__ + "img/yg02-03.d43b3593.png";